import DEFINE from 'constants/Define';
import { HeaderListComponent, PageListComponent } from 'containers/backend/common/component/Index'
import Wrapper from 'containers/backend/common/component/Wrapper';
import { getPermissionActions } from 'helpers/functions';
import { useGetListBundleReport } from 'hooks/report/useGetListBundleReport';
import moment from 'moment';
import React, { useState, useEffect } from 'react'
import './BundleReport.less'
import BundleReportList from './BundleReportList/BundleReportList';
import * as Func from 'helpers/functions';

const BundleReport = (props) => {
    //! Props
    const {t, match, exportBundleExcel, bundleReportState} = props;
    //! State

    const permissionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BUNDLE_REPORT);
    const [query, setQuery] = useState({
        startDate: moment.utc().startOf('isoWeeks'),
        endDate:  moment.utc().endOf('days'),
        filterByCheckIn: false,
        filterByCheckOut: false,
        filterType: 'saleDate',
        pageIndex:  1,
        pageSize: 10
    })
    const {data: bundleReportList, isLoading, error, filterParams, refreshData} = useGetListBundleReport(query);

    //! Function
    const onChangeTable = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        newFilters = {...newFilters, startDate: query.startDate, endDate: query.endDate,filterType: query.filterType, filterByCheckIn: query.filterByCheckIn, filterByCheckOut: query.filterByCheckOut};
        setQuery(newFilters);
    }
    const onSelectTypeReport = (value) => {
        if(value === 'saleDate'){
            setQuery({...query, filterByCheckIn: false, filterByCheckOut: false, filterType: value})
        }else if(value === 'checkIn'){
            setQuery({...query, filterByCheckIn: true, filterByCheckOut: false, filterType: value})
        }else{
            setQuery({...query, filterByCheckIn: false, filterByCheckOut: true, filterType: value})
        }
    }
    //! Effect

    //! Render
  return (
    <PageListComponent className="page-sale-report">
        <HeaderListComponent
            path={match.path}
            groupPath={'orders'}
            titleHeader={t('item.report.bundleReport')}
        />
        <Wrapper className="bundle-report">
            <BundleReportList
                t={t}
                match={match}
                permissionActions={permissionActions}
                bundleReportList={bundleReportList}
                isLoading={isLoading}
                query={query}
                setQuery={setQuery}
                onChangeTable={onChangeTable}
                onSelectTypeReport={onSelectTypeReport}
                exportBundleExcel={exportBundleExcel}
                bundleReportState={bundleReportState}
            />
        </Wrapper>
    </PageListComponent>        
  )
}

export default BundleReport